import { buildModelManager } from "../builder.js";
const DefaultAmendmentRequestSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  notes: true,
  proofDocument: { url: true, mimeType: true, fileName: true },
  proposedChange: true,
  reason: true,
  requestedById: true,
  reviewedAt: true,
  reviewedBy: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "amendmentRequest";
const pluralModelApiIdentifier = "amendmentRequests";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAmendmentRequestSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAmendmentRequestSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAmendmentRequestSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAmendmentRequestSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAmendmentRequestSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAmendmentRequestSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAmendmentRequestSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAmendmentRequest",
    operationReturnType: "CreateAmendmentRequest",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      amendmentRequest: { required: false, type: "CreateAmendmentRequestInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAmendmentRequestSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAmendmentRequests",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAmendmentRequestsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAmendmentRequestSelection
  },
  {
    type: "action",
    operationName: "updateAmendmentRequest",
    operationReturnType: "UpdateAmendmentRequest",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      amendmentRequest: { required: false, type: "UpdateAmendmentRequestInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAmendmentRequestSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAmendmentRequests",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAmendmentRequestsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAmendmentRequestSelection
  },
  {
    type: "action",
    operationName: "upsertAmendmentRequest",
    operationReturnType: "UpsertAmendmentRequest",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      amendmentRequest: { required: false, type: "UpsertAmendmentRequestInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAmendmentRequestResult": { hasReturnType: false },
      "... on UpdateAmendmentRequestResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAmendmentRequestSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAmendmentRequests",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAmendmentRequestsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAmendmentRequestSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "amendmentRequestGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AmendmentRequestManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAmendmentRequestSelection,
  operations
);
export {
  AmendmentRequestManager,
  DefaultAmendmentRequestSelection
};
//# sourceMappingURL=AmendmentRequest.js.map
